import { ShieldCheck } from "lucide-react";
import { ESCROW_SEAL, LEGAL_LINE } from "@/components/fleet/legalContent";

export const EscrowSeal = ({ testid = "escrow-seal", showLegal = true }) => (
  <div data-testid={testid} className="rounded-xl border border-[#10B981]/40 bg-[#10B981]/10 p-4 flex gap-3 items-start">
    <ShieldCheck size={24} className="text-[#10B981] shrink-0" />
    <div className="flex flex-col gap-1">
      <span className="font-bold text-white leading-snug">{ESCROW_SEAL}</span>
      {showLegal && <span className="text-xs text-[#94A3B8] leading-relaxed">{LEGAL_LINE}</span>}
    </div>
  </div>
);
